import GetData from "@/utils/request.js"

const {
  $get,
  $post
} = new GetData();

export const getCourseInfo = (id, adminId) => {
  return $get('/h5/goods/get/' + id, { adminId });
}
export const isGoodsGroup = (id) => {
  return $get('/h5/myorder/isGoodsGroup?goodsId=' + id);
}

export const getPresentInfo = (id) => {
  return $get('/h5/order/getPresentInfo?orderNo=' + id);
}

//领取课程
export const getGroupGoods = (id) => {
  return $get('/h5/order/getGroupGoods?orderNo=' + id);
}

//领取成功接口
export const ordersuccess = (id) => {
  return $get('/h5/order/ordersuccess?orderNo=' + id);
}

//优惠介绍
export const getGoodsPackageList = (id) => {
  return $get('/h5/myorder/getGoodsPackageList?goodsId=' + id);
}



export default {
  getCourseInfo,
  isGoodsGroup,
  getPresentInfo,
  getGroupGoods,
  ordersuccess,
  getGoodsPackageList
}
